module.exports = __webpack_public_path__ + "static/img/Josh-Schuster.e4e51f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Josh-Schuster.jpg
// module id = syfg
// module chunks = 0